export const Props = () => ({
  //Напрвление перемотки
  text: { type: String }
});